/**
 * Legal acceptances (Phase 5, ACC-02/03/04): Terms of Service, Privacy Policy and the BAA.
 * Component → LegalService → apiClient.
 */

import { apiClient } from './api-client';
import type { PendingLegalDoc } from '../types/permissions';

export interface BaaDocument {
  content: string;
  content_hash: string;
  version?: string;
}

export interface BaaAcceptRequest {
  agreed_by_name: string;
  work_email: string;
  content_hash: string;
  /** 2-150 characters */
  signer_title: string;
  authority_attested: true;
}

export const SIGNER_TITLE_MIN = 2;
export const SIGNER_TITLE_MAX = 150;

export class LegalService {
  /** POST /users/me/legal/accept. A 409 LEGAL_VERSION_STALE means the versions changed: reload permissions. */
  static async accept(acceptances: PendingLegalDoc[]): Promise<void> {
    await apiClient.post('/users/me/legal/accept', {
      acceptances: acceptances.map(({ docType, version }) => ({ docType, version })),
    });
  }

  /** GET /admin/agency/baa/current: the BAA text to sign, its hash and version. */
  static async getCurrentBaa(): Promise<BaaDocument> {
    const response = await apiClient.get<BaaDocument>('/admin/agency/baa/current');
    return response.data;
  }

  /** POST /admin/agency/baa/accept (owner or admin). */
  static async acceptBaa(request: BaaAcceptRequest): Promise<void> {
    await apiClient.post('/admin/agency/baa/accept', request);
  }

  /** GET /admin/agency/baa/download (owner or admin): a short-lived download URL for the signed PDF. */
  static async getBaaDownloadUrl(): Promise<string> {
    const response = await apiClient.get<{ downloadUrl: string }>('/admin/agency/baa/download');
    return response.data.downloadUrl;
  }
}

export default LegalService;
